import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/assets/js/constants';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';

export const breakpoints = {
    desktop: '1559px',
    sDesktop: '1280px',
    tablet: '1024px',
    mobile: '760px',
    sMobile: '535px',
    phone: '375px',
};

export const DistrictLayout = styled.div`
    margin-bottom: -50px;
    width: 100%;
    background-color: #E5E5E5;
`;

export const InnerContainer = styled.div`
    display: block;
    width: 1360px;
    margin: 0 auto;

    @media (max-width: ${breakpoints.desktop}) {
        width: 88%;
    }

    @media (max-width: ${breakpoints.sDesktop}) {
        width: 96%;
    }

    @media (max-width: ${breakpoints.tablet}) {
        width: 94%;
    }

    @media (max-width: ${breakpoints.mobile}) {
        width: 96%;
    }
`;

export const AddressCardBlock = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 64px;

    @media (max-width: ${breakpoints.tablet}) { 
        width: 100%;
        margin-bottom: 46px;
        display: flex;
    }

    @media (max-width: ${breakpoints.mobile}) { 
        display: none;
    }

    @media (max-width: ${breakpoints.sMobile}) { 
        display: block;
    }
`;

export const CustomSwiperСardBlock = styled(NukaCarousel)`
    padding-left: 0 !important;
    padding-right: 0 !important;
    display: none;
    
    & section,
    & div {
        outline: none;
    }

    & > section > div.slider-frame {
        padding: 24px 0 !important;
    }

    @media (max-width: ${breakpoints.tablet}) { 
        display: none;
    }

    @media (max-width: ${breakpoints.mobile}) { 
        display: block;
        margin-bottom: 20px;
    }

    @media (max-width: ${breakpoints.sMobile}) { 
        display: none;
    }
`;

export const CheckDistrictBlock = styled.div`
    margin-bottom: 64px;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    @media (max-width: ${breakpoints.tablet}) {
        display: block;
        margin-bottom: 46px;
    }
`;

export const FormTitle = styled.h1`
    width: 100%;
    ${FONTS.H1};

    @media screen and (max-width: ${breakpoints.sDesktop}) {
        margin-top: 81px;
    }

    @media screen and (max-width: ${breakpoints.tablet}) {
        margin-top: 40px;
        margin-bottom: 34px;
        ${FONTS.H2};
    }

    @media screen and (max-width: ${breakpoints.mobile}) {
        ${FONTS.H3};
}    
`;

export const FormSubTitle = styled.h2`
    width: 100%;
    ${FONTS.H2};
    margin-bottom: 24px;

    @media screen and (max-width: ${breakpoints.tablet}) {
        ${FONTS.H3};
}    
`;

export const TariffTitle = styled(FormSubTitle)`
    margin-bottom: 8px;
`;

export const FormDescTitle = styled.h2`
    width: 100%;
    ${FONTS.H2};
    margin-bottom: 14px;

    @media screen and (max-width: ${breakpoints.tablet}) {
        ${FONTS.H3};
    }    
`;

export const DistrictDescription = styled.div`
    display: block;
    background: #FFFFFF;
    border-radius: 16px;
    padding: 40px;
    width: calc(100% - 473px);
    height: 508px;
    overflow: hidden;
    margin-right: 32px;

    &:last-child { 
        margin-right: 0
    }

    @media (max-width: ${breakpoints.tablet}) {
        width: 100%;
        height: 480px;
        padding: 35px 40px 40px 40px;
    }

    @media (max-width: ${breakpoints.mobile}) {
        height: 807px;
    }

    @media (max-width: ${breakpoints.phone}) {
        width: 100%;
        height: fit-content;
    }
`;

export const DistrictDiscTitle = styled.h2`
    ${FONTS.H3};
    margin-bottom: 24px;
`;

export const DistrictText = styled.div`
    ${FONTS.M}
`;

export const DistrictDescList = styled.ul`
    display: block;
    margin-top: 12px;
    list-style-type: disc;
    margin-left: 40px;
`;

export const DistrictDescItem = styled.li`
    ${FONTS.S}
`;

export const CustomSwiper = styled(NukaCarousel)`
    padding-left: 0 !important;
    padding-right: 0 !important;
    
    & section,
    & div {
        outline: none;
    }

    & > section > div.slider-frame {
        padding: 24px 0 !important;
    }
`;
